import { ModuleTime } from "../../../spark-overview/components/StageSchedule/ModuleLink/ModuleTime.jsx";
import styles from "./StepDuration.css.ts";

/**
 * Component that calculates and displays the step duration in minutes.
 *
 * The `StepDuration` component determines the appropriate display of duration
 * for a given step within a set of station steps. It will show the duration for
 * a single step or the total duration for multiple steps based on the provided `stationSteps` array.
 *
 * @param {Object} props - The props object.
 * @param {Object} props.step - The step object.
 * @param {Array} props.stationSteps - An array of step objects representing the station steps.
 * @returns {JSX.Element|null} The JSX element displaying either the step duration or the total duration, or `null` if no duration is available.
 */
export const StepDuration = ({ step, stationSteps }) => {
  if (!stationSteps || stationSteps.length === 1 || stationSteps[0] !== step) {
    if (!step.recommendedMinutes) return null;
    return (
      <span className={styles.duration}>
        <ModuleTime duration={step.recommendedMinutes} />
      </span>
    );
  } else {
    const totalMins = stationSteps.reduce(
      (sum, st) => sum + st.recommendedMinutes,
      0,
    );
    if (!totalMins) return null;
    return (
      <span className={styles.duration}>
        <ModuleTime duration={step.recommendedMinutes} />
      </span>
    );
  }
};
